import React, { type FC } from 'react'
import { RainbowKitProvider } from '@rainbow-me/rainbowkit'
import { QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient } from '@tanstack/react-query'
import { persistQueryClient } from '@tanstack/react-query-persist-client'
import { WagmiProvider } from 'wagmi'

import {
  BlockUpdater,
  RefreshContextProvider,
  TransactionContextProvider,
  TransactionUpdater,
} from 'services'
import { CustomThemeProvider, ThemedGlobalStyle } from 'theme'
import { TourGuideProvider } from 'context/tour-guide/provider'
import { StoreProvider } from 'services/store'
import { Provider as JotaiProvider } from 'jotai'
import { wagmiConfig } from 'services/wallet/chains'
import { CACHE_TIME } from 'services/query/index'
import { createIDBPersister } from 'services/query/persister'
import { ErrorBoundary } from 'components/error-boundary'

import App from './App'
import { ErrorPage } from 'pages/error'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: CACHE_TIME,
      staleTime: CACHE_TIME,
      refetchInterval: CACHE_TIME,
    },
  },
})

persistQueryClient({
  queryClient,
  persister: createIDBPersister('phuture-finance-graphql'),
})

const Inner: FC = () => {
  return (
    <React.StrictMode>
      <Router>
        <QueryClientProvider client={queryClient}>
          <JotaiProvider>
            <StoreProvider>
              <CustomThemeProvider>
                <TourGuideProvider>
                  <WagmiProvider config={wagmiConfig} reconnectOnMount>
                    <RainbowKitProvider>
                      <RefreshContextProvider>
                        <TransactionContextProvider>
                          <BlockUpdater />
                          <TransactionUpdater />
                          <ThemedGlobalStyle />
                          <HelmetProvider>
                            <App />
                          </HelmetProvider>
                        </TransactionContextProvider>
                      </RefreshContextProvider>
                    </RainbowKitProvider>
                  </WagmiProvider>
                </TourGuideProvider>
              </CustomThemeProvider>
            </StoreProvider>
          </JotaiProvider>
        </QueryClientProvider>
      </Router>
    </React.StrictMode>
  )
}

export const Root: FC = () => (
  //TODO: Build a proper error message
  <ErrorBoundary
    fallback={() => {
      return <ErrorPage />
    }}
  >
    <Inner />
  </ErrorBoundary>
)
